import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"pencil\"><path d=\"M28.27 7L25 3.73a2.08 2.08 0 00-2.92 0L4.94 20.87 3.15 28a.7.7 0 00.67.86h.17l7.14-1.79L28.27 9.93a2.08 2.08 0 000-2.93zm-21 14.4L20.48 8.15l3.37 3.37-13.26 13.26a14.57 14.57 0 00-3.37-3.37zm-.87 1.87a12.85 12.85 0 012.33 2.33l-3.11.78zM26.85 8.52l-1.59 1.59-3.37-3.37 1.59-1.59a.07.07 0 01.1 0l3.27 3.27a.09.09 0 010 .1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/pencil.svg
// module id = QBLF
// module chunks = 39 44